'use strict';
import {DownloadService} from './DownloadService';
import {FileDialogService} from './FileDialog';
import {FilePickerFactory} from './FilePickerFactory';
import {OnReadFileDirective} from './OnReadFileDirective';

/**
 * Module dependencies
 */
const angular = require('angular');

export const fileDialogModule = angular
  .module('app.core-utilities.file-dialog', [])
  .service('$download', DownloadService)
  .factory('FileDialog', FileDialogService)
  .service('FilePickerFactory', FilePickerFactory)
  .directive('onReadFile', OnReadFileDirective)
;



// WEBPACK FOOTER //
// ./src/js/core-utilities/file-dialog/index.js